import React from 'react';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';
import { InfiniteSlider } from '@components/InfiniteSlider';
import { JoykitIcon } from '@components/JoykitIcon';
import { CloudImageRow } from '@components/CloudImageRow/CloudImageRow';
import { rachelZoePageData } from '@data-ts/pages/rachel-zoe';
import { groupImages, allGroupImages, SECTION_ID, AUTO_PLAY_INTERVAL, SLIDE_SPEED, EASING } from './HeadToToeWeddingSection.constants';
import { useHeadToToeWeddingSectionController } from './HeadToToeWeddingSection.controller';
import {
  StyledText,
  StyledGroupColumn,
  StyledCircleFlex,
  StyledTitleText,
  StyledContentText,
  StyledImageColumns,
  StyledImageColumn,
  StyledItemColumn,
  StyledItemWrapper,
  StyledCarousel,
  DisplayOnMobile,
  DisplayAboveMobile,
} from './HeadToToeWeddingSection.styles';

const headToToeData = rachelZoePageData.sections.headToToe;

export const HeadToToeWeddingSection: React.FC = () => {
  const {
    activeSlide,
    isMouseHover,
    handleOnHover,
    handleOnLeave,
    handleBeforeSlide,
    handleAfterSlide,
  } = useHeadToToeWeddingSectionController(groupImages.length);
  return (
    <Box as="section" id={SECTION_ID} paddingTop={[11, 12]} marginTop={[6, 0]} paddingBottom={[0, 10]}>
      <StyledText tagName="h2" variant="hed56" color="neutra6" textAlign="center">
        {headToToeData.title}
      </StyledText>
      <DisplayOnMobile marginY={10}>
        <InfiniteSlider scrollName="rachelzoe-head-to-toe" images={allGroupImages} />
      </DisplayOnMobile>
      <DisplayAboveMobile marginY={10}>
        <StyledCarousel
          speed={SLIDE_SPEED}
          easing={EASING}
          pauseOnHover={false}
          autoplay={!isMouseHover}
          autoplayInterval={AUTO_PLAY_INTERVAL}
          slideIndex={activeSlide}
          withoutControls={true}
          beforeSlide={handleBeforeSlide}
          afterSlide={handleAfterSlide}
        >
          {groupImages.map((groupImage, index) => (
            <CloudImageRow key={index + SECTION_ID} images={groupImage} />
          ))}
        </StyledCarousel>
      </DisplayAboveMobile>
      <StyledGroupColumn centered verticalAlign="flex-start">
        {headToToeData.groups.map((item, index) => (
          <StyledItemColumn key={index} width={3}>
            <StyledItemWrapper
              onMouseOver={() => handleOnHover(index)}
              onMouseLeave={handleOnLeave}
              alignItems="center"
              flexDirection="column"
            >
              <StyledCircleFlex>
                <JoykitIcon size={32} color="humana5" name={item.icon} />
              </StyledCircleFlex>
              <StyledTitleText marginTop={7} tagName="h3" variant="sectionEyeBrow20" color="neutra6" textAlign="center">
                {item.title}
              </StyledTitleText>
              <StyledContentText tagName="h3" variant="sectionEyeBrow20" color="neutra5" textAlign="center">
                {item.body}
              </StyledContentText>
            </StyledItemWrapper>
          </StyledItemColumn>
        ))}
      </StyledGroupColumn>
      <StyledImageColumns verticalAlign="flex-start">
        <StyledImageColumn width={4} left={activeSlide * 33}>
          <Box marginTop={9} style={{ width: '100%' }}>
            <CloudImage src="rachel zoe/val-props-carousel/squiggle.svg" width="100%" height={20} />
          </Box>
        </StyledImageColumn>
      </StyledImageColumns>
    </Box>
  );
};
